import Home from "./pages/home-new";
import Appointments from "./pages/appointments";
import PatientInfo from "./pages/patient-info";
import PatientTrendAnalysis from "./pages/patient-trend-analysis";
import "./pages/appointments-patient";
import RecentReports from "./pages/recent-reports";
import TeleConsole from "./pages/tele-console";
import Console from "./pages/console";
import ReportChart from "./pages/ReportChart";
import PatientLayout from "./components/Layout/PatientLayout-new";
import NormalLayout from "./components/Layout/NormalLayout";
import VideoConfMain from "./components/VideoConf/Main";
import VideoConfRoom from "./components/VideoConf/Room";
import DoctorHome from "./pages/doctor-home";
import PatientHome from "./pages/patient-home";
import DiabeticBlog from "./pages/blog-diabetic";
import HealthySleepBlog from "./pages/blog-healthysleep";
import HelpAndFaq from "./pages/faq";
import UnderConstruction from "./pages/under_construction";
import ResarchHome from "./pages/patient-home";
import Search from "./pages/search-new";
import ContactUs from "./pages/ContactUs/ContactUs";

// New Added By Tapas
import AbdmServices from "./pages/abdm-services";
import AbdmBenefits from "./pages/abdm-benefits";
import AbdmJoin from "./pages/abdm-join";
import HealthRepo from "./pages/health-repo";
import DtxTool from "./pages/dtx-tool";
import IncentivesPlan from "./pages/incentives-plan";
import HlthtekAdminDemo from "./pages/hlthtek-admin-demo";
import HlthtekDemo from "./pages/hlthtek-demo";
// End By Tapas

//import jQuery from 'jquery';
import DoctorLayout from "./components/Layout/DoctorLayout-new";

import "./App.scss";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import { useState, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import AppointmentsPatient from "./pages/appointments-patient";
import CareContext from "./pages/hlthtek-demo/components/CareContext";
import Consent from "./pages/hlthtek-demo/components/Consent";
import AdminServices from "./pages/hlthtek-demo/components/AdminServices";
import UploadReport from "./pages/hlthtek-demo/components/UploadReport";
import RegisterPatient from "./pages/hlthtek-demo/components/RegisterPatient";
import PatientRecords from "./pages/patient-records/PatientRecords";
import GenerateConsent from "./pages/hlthtek-demo/components/GenerateConsent";
import GetExistingDetails from "./pages/hlthtek-demo/components/GetExistingDetails";
import AddUpdateServices from "./pages/hlthtek-demo/components/AddUpdateServices";
import PatientDetails from "./pages/hlthtek-demo/components/PatientDetails";
import ScanPatientQR from "./pages/hlthtek-demo/components/ScanPatientQR";
import ExchangePatientEMR from "./pages/hlthtek-demo/components/ExchangePatientEMR";
import Login from "./pages/login/Login";
import FHIR from "./pages/hlthtek-demo/components/FHIR";
import Register from "./pages/login/Register";
import TransactionRecords from "./pages/hlthtek-demo/components/TransactionRecords";
import Timeline from "./components/Timeline/Timeline";
import TimelineMain from "./components/Timeline/TimelineMain";
import DicomMain from "./components/Dicom/DicomMain";
import ChatPdf from "./pages/hlthtek-demo/components/ChatPdf";
import FacilityDetails from "./pages/hlthtek-admin-demo/components/FacilityDetails";
import FacilityList from "./pages/hlthtek-admin-demo/components/FacilityList";
import ClientDetails from "./pages/hlthtek-admin-demo/components/ClientDetails";
import FacilityCustomer from "./pages/hlthtek-admin-demo/components/FacilityClient";
import FacilityPartner from "./pages/hlthtek-admin-demo/components/FacilityPartner";
import PartnerDetails from "./pages/hlthtek-admin-demo/components/PartnerDetails";
import FacilityUsers from "./pages/hlthtek-admin-demo/components/FacilityUsers";
import UserDetails from "./pages/hlthtek-admin-demo/components/UserDetails";
import WellnessMainPage from "./pages/WellnessMainPage/WellnessMainPage";
import Loader from "./pages/hlthtek-admin-demo/components/Loader";
import { useEffect, useRef } from "react";
import axios from "axios";
import AppointmentCalender from "./pages/appointments/AppointmentCalender";
import WeekCalender from "./pages/appointments/WeekCalender";
import MonthCalender from "./pages/appointments/MonthCalender";
import EstimateAdditon from "./pages/billing-payment/EstimateAdditon";
import InvoicePreview from "./pages/billing-payment/InvoicePreview";
import InvoiceAddition from "./pages/billing-payment/InvoiceAddition";
import EstimatePreview from "./pages/billing-payment/EstimatePreview";
import EditEstimate from "./pages/billing-payment/EditEstimate";
import ViewEstimate from "./pages/billing-payment/ViewEstimate";
import Payment from "./pages/billing-payment/Payment";
import Invoice from "./pages/billing-payment/Invoice";
import Refund from "./pages/billing-payment/Refund";
// import Estimate from "./pages/billing-payment/Estimate"; // Cost Estimates - commented out for now
import Item from "./pages/billing-payment/Item";
// import Product from "./pages/billing-payment/Product";
import Patient from "./pages/billing-payment/Patient";
import SideNavbar from "./pages/billing-payment/SideNavbar";
import ViewInvoice from "./pages/billing-payment/ViewInvoice";
import RefundReceipt from "./pages/billing-payment/RefundReceipt";
import InvoiceReceiptTabs from "./pages/billing-payment/InvoiceReceiptTabs";
import EditInvoice from "./pages/billing-payment/EditInvoice";
import Reports from "./pages/billing-payment/Reports";

import DoctorConsole from "./pages/doctor-console/DoctorConsole";
import StagingArea from "./pages/billing-payment/StagingArea";
import DoctorsAddition from "./pages/hlthtek-admin-demo/components/DoctorsAddition";
import DoctorList from "./pages/hlthtek-admin-demo/components/DoctorList";
import BedManagement from "./pages/hlthtek-admin-demo/components/BedManagement";
import BedTypeManagement from "./pages/hlthtek-admin-demo/components/BedTypeManagement";
import NurseManagement from "./pages/hlthtek-admin-demo/components/NurseManagement";
import DischargeTemplateManagement from "./pages/hlthtek-admin-demo/components/DischargeTemplateManagement";
import DoctorAppointmentsCards from "./pages/appointments/DoctorAppointmentsCards";
import LabTest from "./pages/lab-technician/LabTest";
import LabRequisitionPrint from "./pages/lab-technician/LabRequisitionPrint";
import RadiologyTest from "./pages/radiology-technician/RadiologyTest";
import RadiologyRequisitionPrint from "./pages/radiology-technician/RadiologyRequisitionPrint";
import RadiologyTemplates from "./pages/radiology-technician/RadiologyTemplates";
import OtDashboard from "./pages/ot/pages/OtDashboard";
import OtSchedule from "./pages/ot/pages/OtSchedule";
import OtCases from "./pages/ot/pages/OtCases";
import OtCaseNew from "./pages/ot/pages/OtCaseNew";
import OtCaseDetail from "./pages/ot/pages/OtCaseDetail";
import OtBoard from "./pages/ot/pages/OtBoard";
import OtFinalList from "./pages/ot/pages/OtFinalList";
import OtOrders from "./pages/ot/pages/OtOrders";
import OtMasters from "./pages/ot/pages/OtMasters";
import OtReports from "./pages/ot/pages/OtReports";
import OTAppShell from "./pages/ot/OTAppShell";
import OtChargeCapture from "./pages/ot-charge-capture/OtChargeCapture";
import LandingPage from "./pages/doctor/LandingPage";
import CareContextCreationNonAbdm from "./pages/hlthtek-demo/components/CareContextCreationNonAbdm";
import MedicinesManagement from "./pages/pharmacy-user/MedicinesManagement";
import ABDMData from "./pages/abdm/ABDMData";
import HTMatedata from "./pages/HTMate/HTMatedata";
import ElectronicHealthRecords from "./pages/login/ElectronicHealthRecords";
import HTHRPHealthRepositoryProvider from "./pages/login/HTHRPHealthRepositoryProvider";
import HTBridgeConnector from "./pages/login/HTBridgeConnector";
import UploadReprortTable from "./pages/hlthtek-demo/components/UploadReprortTable";
import DepartmentManipulation from "./pages/hlthtek-admin-demo/components/DepartmentManipulation";
import { BrandingProvider } from "./BrandingProvider";
import BrandingManagement from "./pages/hlthtek-admin-demo/components/BrandingManagement";
import DoctorConsoleManager from "./pages/doctor-console-manager";
import CaseSheetAccessManager from "./pages/case-sheet-access";
import MainLanding from "./components/Landing/MainLanding";
import WebsiteIntegration from "./components/websiteIntegration/WebsiteIntegration.js";

import FooterDetails from "./pages/FooterExtraPages";
import AboutUs from "./pages/FooterExtraPages/AboutUs";
import NewsAndMedia from "./pages/FooterExtraPages/NewsAndMedia";
import { toast } from "react-toastify";
import ScanShareRecords from "./pages/scan-share records";
import ConnectorVisualization from "./pages/sample-folder/connectorVisualization";
// import Product from "./pages/billing-payment/Product"; // Product Inventory - commented out for now
import IndexedDBManager from "./pages/login/IndexedDBManager";
import License from "./pages/login/License";
import LicenseExpiryPopup from "./components/LicenseExpiryPopup";
import LicenseInfoPopup from "./pages/login/LicenseInfoPopup";
import StorageUsageDialogInside from "./pages/login/StorageUsageDialogInside";
import { useHistory } from "react-router-dom";
import AccessDeniedPage from "./pages/hlthtek-admin-demo/components/AccessDeniedPage";
import InitialObservation from "./pages/doctor-console/HistoriesData/InitialObservation";
import RestrictedRoute from "./pages/login/RestrictedRoute";
import MainLandingEntry from "./pages/application-landing";
import {
  BED_MANAGEMENT_PERMISSION,
  BED_TYPE_MANAGEMENT_PERMISSION,
  NURSE_MANAGEMENT_PERMISSION,
  DISCHARGE_TEMPLATE_PERMISSION,
  SCHEDULE_MANAGEMENT_PERMISSION,
} from "./pages/application-landing/constants";
import QuickConsultation from "./pages/doctor-console/QuickConsultation/QuickConsultation";
import LayoutWithbg from "./components/LayoutWithbg";
import CreateCareContext from "./pages/hlthtek-demo/components/CreateCareContext";
import PasswordApproval from "./pages/password-approval/PasswordApproval";
import PasswordChangeModal from "./components/PasswordChangeModal/PasswordChangeModal";
import { usePermissions } from "./pages/login/PermissionContext";
import DoctorScheduling from "./pages/hlthtek-admin-demo/DoctorScheduling/DoctorScheduling";
import PatientRegistrationWizard from "./pages/patient-registration/PatientRegistrationWizard";
import PatientPasswordApproval from "./pages/password-approval/PatientPasswordApproval";
import DataUploadByDoctor from "./pages/Patient-data-doctor-upload/DataUploadByDoctor";
import VoiceUploadByPatient from "./pages/doctor-console/Utils/VoiceUploadByPatient";
import QrDocumentUpload from "./pages/qr-document-upload";
import HandwrittenPrescriptionUpload from "./pages/doctor-console/Utils/HandwrittenPrescriptionUpload";
import DoctorConsoleIpd from "./pages/ipd/pages/doctor-console-ipd";
import NurseTasks from "./pages/ipd/pages/nurse-tasks/NurseTasks";
import BedAllocation from "./pages/ipd/pages/bed-allocation/BedAllocation";
import BedRetentionManagement from "./pages/ipd/pages/bed-retention/BedRetentionManagement";
import BedTransferRequisitionList from "./pages/ipd/pages/bed-transfer-requisition/BedTransferRequisitionList";
import IpdPatientRegisterShell from "./pages/ipd/pages/patient-list/IpdPatientRegisterShell";
import EmergencyToIpdForm from "./pages/ipd/pages/emergency-to-ipd/EmergencyToIpdForm";
import ApprovalsCenter from "./pages/ipd/pages/approvals/ApprovalsCenter";
import CancellationRulesAdmin from "./pages/ipd/pages/settings/CancellationRulesAdmin";
import HousekeepingSettingsAdmin from "./pages/ipd/pages/settings/HousekeepingSettingsAdmin";
import EmergencyTrackingBoard from "./pages/emergency/pages/tracking-board/TrackingBoard";
import EmergencyAllVisits from "./pages/emergency/pages/all-visits/AllVisits";
import EmergencyBedManagement from "./pages/emergency/pages/bed-management/BedManagement";
import EmergencyDeathRegister from "./pages/emergency/pages/death-register/DeathRegister";
import EmergencyShell from "./pages/emergency/components/EmergencyShell";
import EmergencyDepartmentSetup from "./pages/emergency/pages/department-setup/DepartmentSetup";
import EmergencyRegisterPatient from "./pages/emergency/pages/register/RegisterPatient";
import EmergencyVisitDetail from "./pages/emergency/pages/visit-detail/VisitDetail";
import NurseDashboardShell from "./pages/nurse-dashboard/NurseDashboardShell";
import { IpdDataProvider } from "./pages/ipd/context/IpdDataContext";
import MobileScan from "./pages/mobile-scan/MobileScan";
import IPDBillingDashboard from "./pages/IPDBillingDashboard.js";
import IPDBillingPatientJourney from "./pages/IPDBillingPatientJourney.js";
import IPDBillingChargeCapture from "./pages/IPDBillingChargeCapture.js";
import IPDBillingAddCharge from "./pages/IPDBillingAddCharge.js";
import IPDBillingDeposits from "./pages/IPDBillingDeposits.js";
import IPDBillingInsurance from "./pages/IPDBillingInsurance.js";
import IPDBillingInvoice from "./pages/IPDBillingInvoice.js";
import IPDBillingRefundCancel from "./pages/IPDBillingRefundCancel.js";
import IPDBillingCashCounter from "./pages/IPDBillingCashCounter.js";
import IPDBillingApprovals from "./pages/IPDBillingApprovals.js";
import IPDBillingLedger from "./pages/IPDBillingLedger.js";
import IPDBillingDischarge from "./pages/IPDBillingDischarge.js";
import IPDBillingReports from "./pages/IPDBillingReports.js";
import IPDBillingPricing from "./pages/IPDBillingPricing.js";
import IPDBillingPayouts from "./pages/IPDBillingPayouts.js";
import InventoryApp from "./pages/inventory/InventoryApp";
import InvSettings from "./pages/inventory/pages/Settings";
import IPDBillingAppShell from "./pages/ipd-billing/components/IPDBillingAppShell";
import CorporateRateCard from "./pages/CorporateRateCard.js";
import SchemeServiceNames from "./pages/SchemeServiceNames.js";
import BillingManagerDashboard from "./pages/BillingManagerDashboard.js";
import PackageBilling from "./pages/PackageBilling.js";
import PackageDashboard from "./pages/PackageDashboard.js";
import ServiceMaster from "./pages/ServiceMaster.js";
import PatientAdmissionIpd from "./pages/ipd/pages/patient-admission-ipd/PatientAdmissionIpd.js";
const TeleConsolePatient = lazy(() => import("./pages/tele-console-patient"));
const TelemedicineConsole = lazy(
  () => import("./components/Telemedicine/Telemedicine"),
);
const GuestJoinCall = lazy(
  () => import("./pages/guest-join-call/GuestJoinCall"),
);
// import PatientAdmissionIpd from "./pages/ipd/pages/patient-admission-ipd";

function App() {
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [brandingData, setBrandingData] = useState(null);
  const [showStoragePopup, setShowStoragePopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const refreshToken = sessionStorage.getItem("refreshToken");
  const [shouldLogout, setShouldLogout] = useState(false);
  const history = useHistory();
  const [roleType, setRoleType] = useState(
    sessionStorage.getItem("roleType") || "",
  );
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : "",
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const allowedRoles = [
    "facility user",
    "user",
    "lab user",
    "pharmacy user",
    "facility admin",
    "customer admin",
    "doctor",
    // Inventory Suite roles — PO and GRN PDFs read collateral_image off BrandingContext.
    "store_manager",
    "store_keeper",
    "inventory_staff",
  ];
  const [searchText, setSearchText] = useState("");
  const [refreshList, setRefreshList] = useState("");
  const [loading, setLoading] = useState(false);
  const pendingLoaderRequestsRef = useRef(0);
  const { userInfo, refreshPermissions } = usePermissions();
  const [forcePwdModalOpen, setForcePwdModalOpen] = useState(false);
  const [passwordChanged, setPasswordChanged] = useState(false);

  function OverlayCleanup() {
    const location = useLocation();

    const isModalInFlight = () => Boolean(
      document.querySelector(".modal") ||
      document.querySelector(".MuiDialog-container") ||
      document.querySelector(".MuiDialog-root[role='presentation']") ||
      document.querySelector(".MuiModal-root[role='presentation']"),
    );

    const neutralize = (node) => {
      node.style.setProperty("display", "none", "important");
      node.style.setProperty("pointer-events", "none", "important");
    };

    const staleBackdrops = () => [
      ...document.querySelectorAll(".modal-backdrop"),
      ...document.querySelectorAll("body > .MuiBackdrop-root, body > .MuiModal-backdrop"),
    ];

    useEffect(() => {
      // If a bootstrap/modal backdrop is left behind, it can block all clicks.
      // Clean it up when route changes and no modal is mounted (including fade-out).
      const cleanup = () => {
        if (isModalInFlight()) return;

        staleBackdrops().forEach(neutralize);
        document.body.classList.remove("modal-open");
        document.body.style.removeProperty("padding-right");
        document.body.style.removeProperty("overflow");
      };

      cleanup();
      const t = setTimeout(cleanup, 250);
      return () => clearTimeout(t);
    }, [location.pathname]);

    useEffect(() => {
      // Some API failures can leave/recreate backdrops without navigation.
      // Run a light cleanup loop to keep UI clickable.
      const id = setInterval(() => {
        try {
          if (isModalInFlight()) return;

          const backdrops = staleBackdrops();
          if (
            backdrops.length === 0 &&
            !document.body.classList.contains("modal-open")
          ) {
            return;
          }

          backdrops.forEach(neutralize);
          document.body.classList.remove("modal-open");
          document.body.style.removeProperty("padding-right");
          document.body.style.removeProperty("overflow");
        } catch (e) {
          // ignore
        }
      }, 500);
      return () => clearInterval(id);
    }, []);

    return null;
  }
  const updateList = () => {
    setRefreshList(true);
  };
  const excludedUrlsForLoader = [
    "/snomed/search/",
    "/snomed/suggest/",
    "/snomed/map_icd/",
    "/login/refresh/",
    "/insurance/responses/",
    "/diagnose/",
    "/search_medical_services/",
    "/search_medicines/",
    "/search_vaccines/",
    "/summarize_patient_records/",
    "/get_all_invoices/",
    "/get_all_medical_services/",
    "/get_medical_services/",
    "ipd/billing/service-groups/",
    "ipd/billing/service-classifications/",
    "ipd/billing/service-catalog/services/",
    "ipd/billing/charge-capture/services/",
    "/get_ipd_radiology_tests/",
    "/get_ipd_lab_orders/",
    // Corporate/scheme pricing preview fires per-line on the Add Charge screen —
    // admission-id-agnostic substring so it matches every admission, not just one.
    "billing/corporate-pricing/preview/",
  ];
  const excludedPathnamesForLoader = [
    "/doctor/DoctorConsole",
    "/doctor/QuickConsultation",
    "/doctor/appointments",
    "/ipd-billing/invoices",
    "/ipd-billing/charge-capture",
    "/ipd-billing/charge-capture/add",
  ];
  useEffect(() => {
    // Tracks in-flight loader-eligible requests with a counter rather than a
    // plain boolean — two overlapping requests (very common: this app fires
    // several axios calls in parallel on most screens) previously raced on a
    // single true/false flag, so the first response to land could flip
    // `loading` back to false while a second request was still pending, or a
    // request that errors out (e.g. a CORS-blocked call) could leave it stuck
    // true if the ordering went the other way. That left a full-screen,
    // click-eating overlay (`<Loader show={loading} />`) invisibly stuck open
    // over otherwise-normal-looking pages — inputs stopped responding with no
    // visible sign why.
    const incrementLoading = () => {
      pendingLoaderRequestsRef.current += 1;
      setLoading(true);
    };
    const decrementLoading = () => {
      pendingLoaderRequestsRef.current = Math.max(0, pendingLoaderRequestsRef.current - 1);
      if (pendingLoaderRequestsRef.current === 0) setLoading(false);
    };

    const requestInterceptorId = axios.interceptors.request.use(
      (config) => {
        const isExcludedUrl = excludedUrlsForLoader.some((excludedUrl) =>
          config.url.includes(excludedUrl),
        );

        const isExcludedPath = excludedPathnamesForLoader.includes(
          window.location.pathname,
        );

        // Per-request opt-out: background/polling requests can set
        // `skipGlobalLoader: true` so they don't flash the full-screen logo
        // loader (e.g. the lab orders 30s poll).
        //Skip loader only if both URL and pathname match, or the request opted out
        if (!config.skipGlobalLoader && !(isExcludedUrl && isExcludedPath)) {
          config._countedForGlobalLoader = true;
          incrementLoading();
        }

        return config;
      },

      (error) => {
        return Promise.reject(error);
      },
    );

    const responseInterceptorId = axios.interceptors.response.use(
      (response) => {
        if (response.config?._countedForGlobalLoader) decrementLoading();
        return response;
      },
      (error) => {
        if (error.config?._countedForGlobalLoader) decrementLoading();
        return Promise.reject(error);
      },
    );

    // Without this, every remount (Fast Refresh during dev, or a second
    // mount of this component) registered another pair of interceptors on
    // the shared axios instance without removing the old ones — each stray
    // pair kept incrementing/decrementing the SAME ref independently, which
    // is exactly the kind of drift that can leave the counter, and the
    // loader, permanently out of sync with real in-flight requests.
    return () => {
      axios.interceptors.request.eject(requestInterceptorId);
      axios.interceptors.response.eject(responseInterceptorId);
    };
  }, []);
  console.log("branding..app", brandingData);

  const fetchBrandingData = () => {
    const payload = {
      // functionality: "branding",
      // segment: "images",
      // config_type:"configuration",
      bucket_type: "license",
      bucket_category: "conf",
      file_key: "",
      facility: false,
    };

    axios
      .post(`${REACT_APP_BACKEND_ROUTE_URL}get_facility_branding/`, payload, {
        headers,
      })
      .then((res) => {
        if (res.data.status === "Success") {
          setBrandingData(res.data?.data);
          console.log("branding..demo", res.data?.data);
        } else if (res?.data?.message === "No files found.") {
          toast.info("Branding information not yet provided");
        } else {
          toast.error("Error fetching branding data");
        }
      })
      .catch((err) => {
        console.log("Error fetching branding data:", err);
        toast.error("Error fetching branding data");
      });
  };

  useEffect(() => {
    if (userInfo && userInfo.is_first_login && !passwordChanged) {
      setForcePwdModalOpen(true);
    }
  }, [userInfo, passwordChanged]);

  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");
    const role = sessionStorage.getItem("roleType");

    const allowedRoles = [
      "facility user",
      "user",
      "lab user",
      "pharmacy user",
      "facility admin",
      "doctor",
    ];

    if (accessToken && allowedRoles.includes(role)) {
      fetchThreshold();
    }
  }, []);
  const Logout = () => {
    axios
      .post(`${REACT_APP_BACKEND_ROUTE_URL}logout/`, {
        refresh_token: refreshToken,
      })
      .then((res) => {
        // console.log(res.status);
        sessionStorage.clear();
        // window.location.reload();
        history.push("/login");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchThreshold = () => {
    const org_code = sessionStorage.getItem("ORG_CODE");
    const apiUrl = `${process.env.REACT_APP_BACKEND_ROUTE_URL}assets_usage_threshold_notifier/`;
    const requestBody = { ORG_CODE: org_code };

    axios
      .post(apiUrl, requestBody, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        console.log("outer flag");

        if (response.data.status == "Warning") {
          if (
            response.data.data.db_usage_percent >= 70 ||
            response.data.data.media_usage_percent >= 70
          ) {
            const warningMsg =
              response.data.message ||
              "Data and media limit exceeded. Please contact administrator.";
            setPopupMessage(warningMsg);
            setShowStoragePopup(true);
            setShouldLogout(false);
          } else {
            console.log(response.data);
          }
        } else if (response.data.status == "Failed") {
          const warningMsg =
            response.data.message ||
            "Data and media limit exceeded. Please contact administrator.";
          setPopupMessage(warningMsg);
          setShowStoragePopup(true);
          setShouldLogout(true);
        } else {
          console.log(response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error checking usage:", error);
      });
  };

  useEffect(() => {
    if (authToken && roleType && allowedRoles.includes(roleType)) {
      fetchBrandingData();
    }
  }, []);
  // const pages = [
  //   {
  //     path: "home",
  //     component: <DoctorHome setSearchText={setSearchText} />,
  //   },
  //   // {
  //   //   path: "appointments",
  //   //   component: <Appointments />,
  //   // },
  //   {
  //     path: "appointmentsCards",
  //     component: <DoctorAppointmentsCards />,
  //   },
  //   {
  //     path: "Reports",
  //     // component: <RecentReports />,
  //     component: <ReportChart />,
  //   },
  //   {
  //     path: "observations",

  //     component: <Observation />,
  //   },
  //   {
  //     path: "Billing",

  //     component: <Billing />,
  //   },
  //   {
  //     path: "AppointmentCalender",
  //     component: <AppointmentCalender />,
  //   },
  //   {
  //     path: "MonthCalender",
  //     component: <MonthCalender />,
  //   },
  //   {
  //     path: "WeekCalender",
  //     component: <WeekCalender />,
  //   },
  //   {
  //     path: "tele-console",
  //     component: <TeleConsole />,
  //   },
  //   {
  //     path: "Prescription",
  //     component: <Console />,
  //   },
  //   {
  //     path: "Chart",
  //     component: <ReportChart />,
  //   },
  //   {
  //     path: "tele-console-patient",
  //     component: <TeleConsolePatient />,
  //   },
  //   {
  //     path: "Timeline",
  //     component: <TimelineMain />,
  //   },
  //   {
  //     path: "Dicom",
  //     component: <DicomMain />,
  //   },
  //   {
  //     path: "Wellness",
  //     component: <WellnessMainPage />,
  //   },
  //   {
  //     path: "DoctorConsole",
  //     component: <DoctorConsole />,
  //   },
  return (
    <BrandingProvider brandingData={brandingData}>
      <Router>
        <OverlayCleanup />
        <Helmet>
          <script src={`${process.env.PUBLIC_URL || ""}/assets/js/jquery-3.5.1.min.js`}></script>
        </Helmet>
        <Loader show={loading} />
        <IpdDataProvider>
          <Switch>
            {/* Public guest video call — no auth required */}
            <Route exact path="/join-call">
              <Suspense fallback={<div />}>
                <GuestJoinCall />
              </Suspense>
            </Route>
            {/* Proteckted routes */}

            {/*           
          <Route exact path="/DepartmentManipulation">
            <DoctorLayout setSearchText={setSearchText}>
              <DepartmentManipulation />
            </DoctorLayout>
          </Route>

          <Route exact path="/laboratories">
            <NormalLayout setSearchText={setSearchText}>
              <LabTest />
            </NormalLayout>
          </Route>
          <Route exact path="/pharmacy-user">
            <NormalLayout setSearchText={setSearchText}>
              <MedicinesManagement />
            </NormalLayout>
          </Route>

          <Route exact path="/main-landing">
            <DoctorLayout setSearchText={setSearchText}>
              <MainLandingEntry
                setSearchText={setSearchText}
                setBrandingData={setBrandingData}
              />
            </DoctorLayout>
          </Route>

          <RestrictedRoute path="/patient-local-data" permission="patient 360">
            <DoctorLayout setSearchText={setSearchText}>
              <PatientLocalData />
            </DoctorLayout>
          </RestrictedRoute>

          <Route exact path="/facility_details">
            <DoctorLayout setSearchText={setSearchText}>
              <FacilityDetails updateList={updateList} />
              <FacilityList refreshList={refreshList} />
            </DoctorLayout>
          </Route>

          <Route exact path="/user_details">
            <DoctorLayout setSearchText={setSearchText}>
              <FacilityUsers updateList={updateList} />
              <UserDetails refreshList={refreshList} />
            </DoctorLayout>
          </Route>
          <Route exact path="/facility_doctors">
            <DoctorLayout setSearchText={setSearchText}>
              <DoctorsAddition updateList={updateList} />
              <DoctorList refreshList={refreshList} />
            </DoctorLayout>
          </Route>

          <Route exact path="/care_context">
            <DoctorLayout setSearchText={setSearchText}>
              <CareContextCreationNonAbdm setSearchText={setSearchText} />
            </DoctorLayout>
          </Route>
          <Route exact path="/care_context_non_abdm">
            <DoctorLayout setSearchText={setSearchText}>
              <CareContextCreationNonAbdm setSearchText={setSearchText} />
            </DoctorLayout>
          </Route>

          <Route exact path="/upload_report">
            <DoctorLayout setSearchText={setSearchText}>
              <UploadReport setSearchText={setSearchText} />
            </DoctorLayout>
          </Route>

          <RestrictedRoute
            path="/register_patient"
            permission="manage patients"
          >
            <DoctorLayout setSearchText={setSearchText}>
              <RegisterPatient setSearchText={setSearchText} />
            </DoctorLayout>
          </RestrictedRoute>

          <Route exact path="/add_update_services">
            <DoctorLayout setSearchText={setSearchText}>
              <AddUpdateServices setSearchText={setSearchText} />
            </DoctorLayout>
          </Route>
          <Route exact path="/patient_details">
            <DoctorLayout setSearchText={setSearchText}>
              <PatientDetails setSearchText={setSearchText} />
            </DoctorLayout>
          </Route>
          <Route exact path="/scan_qr">
            <DoctorLayout setSearchText={setSearchText}>
              <ScanPatientQR setSearchText={setSearchText} />
            </DoctorLayout>
          </Route>

          <Route exact path="/login">
            <DoctorLayout setSearchText={setSearchText}>
              <Login setSearchText={setSearchText} />
            </DoctorLayout>
          </Route>
          <Route exact path="/License">
            <DoctorLayout setSearchText={setSearchText}>
              <License setSearchText={setSearchText} />
            </DoctorLayout>
          </Route>

          <Route exact path="/transaction_records">
            <DoctorLayout setSearchText={setSearchText}>
              <TransactionRecords setSearchText={setSearchText} />
            </DoctorLayout>
          </Route>

          <Route path="/doctor/patient">
            <DoctorLayout setSearchText={setSearchText}>
              <Patient />
            </DoctorLayout>
          </Route>

          <Route exact path="/scan_share_records">
            <DoctorLayout>
              <ScanShareRecords />
            </DoctorLayout>
          </Route>

          <Route path="/doctor/Reports">
            <DoctorLayout setSearchText={setSearchText}>
              <ReportChart />
            </DoctorLayout>
          </Route>

          <Route path="/doctor/DoctorConsole">
            <DoctorLayout setSearchText={setSearchText}>
              <DoctorConsole />
            </DoctorLayout>
          </Route> */}
            <Route exact path="/pass_verify">
              <PasswordApproval />
            </Route>
            <Route exact path="/patient_pass_verify">
              <PatientPasswordApproval />
            </Route>
            <Route exact path="/upload_voice">
              <VoiceUploadByPatient />
            </Route>
            <Route exact path="/upload_handwritten_prescription">
              <HandwrittenPrescriptionUpload />
            </Route>
            <RestrictedRoute
              path="/DepartmentManipulation"
              permission="manage departments"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <DepartmentManipulation />
              </DoctorLayout>
            </RestrictedRoute>

            {/* Ahead of /laboratories, which is not exact and would otherwise
              swallow this path. */}
            <RestrictedRoute
              exact
              path="/laboratories/requisition"
              permission="manage lab service"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <LabRequisitionPrint />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/laboratories"
              permission="manage lab service"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <LabTest />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/radiology-services/requisition"
              permission="manage radiology service"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <RadiologyRequisitionPrint />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/radiology-services"
              permission="manage radiology service"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <RadiologyTest />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/radiology-report-templates"
              permission="manage radiology service"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <RadiologyTemplates />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/pharmacy-user"
              permission="manage medicines"
            >
              <NormalLayout setSearchText={setSearchText}>
                <MedicinesManagement />
              </NormalLayout>
            </RestrictedRoute>

            <Route exact path="/main-landing">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <MainLandingEntry
                    setSearchText={setSearchText}
                    setBrandingData={setBrandingData}
                  />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>

            {/* <RestrictedRoute
              path="/patient-local-data"
              permission="manage patients"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <PatientLocalData />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute> */}

            <RestrictedRoute
              path="/qr-document-upload"
              permission="QR based document upload"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <QrDocumentUpload />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/facility_details"
              permission="manage facilities"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <FacilityDetails updateList={updateList} />
                <FacilityList refreshList={refreshList} />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute path="/user_details" permission="manage users">
              <DoctorLayout setSearchText={setSearchText}>
                <FacilityUsers updateList={updateList} />
                <UserDetails refreshList={refreshList} />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/facility_doctors"
              permission="manage doctors"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <DoctorsAddition updateList={updateList} />
                <DoctorList refreshList={refreshList} />
              </DoctorLayout>
            </RestrictedRoute>

            {/* Nurse Management — "manage nurses" permission. Keep in step with
                NURSE_MANAGEMENT_PERMISSION in constants.js. */}
            <RestrictedRoute
              path="/nurse_management"
              permission={NURSE_MANAGEMENT_PERMISSION}
            >
              <DoctorLayout setSearchText={setSearchText}>
                <NurseManagement />
              </DoctorLayout>
            </RestrictedRoute>

            {/* Discharge Template Management — "manage discharge templates"
                permission. */}
            <RestrictedRoute
              path="/discharge_template_management"
              permission={DISCHARGE_TEMPLATE_PERMISSION}
            >
              <DoctorLayout setSearchText={setSearchText}>
                <DischargeTemplateManagement />
              </DoctorLayout>
            </RestrictedRoute>

            {/* Bed Management — "manage beds" permission. Keep in step with
                BED_MANAGEMENT_PERMISSION in constants.js. */}
            <RestrictedRoute
              path="/bed_management"
              permission={BED_MANAGEMENT_PERMISSION}
            >
              <DoctorLayout setSearchText={setSearchText}>
                <BedManagement />
              </DoctorLayout>
            </RestrictedRoute>

            {/* Bed Type Management — "manage wards" permission. Keep in step with
                BED_TYPE_MANAGEMENT_PERMISSION in constants.js. */}
            <RestrictedRoute
              path="/bed_type_management"
              permission={BED_TYPE_MANAGEMENT_PERMISSION}
            >
              <DoctorLayout setSearchText={setSearchText}>
                <BedTypeManagement />
              </DoctorLayout>
            </RestrictedRoute>
            {/* Schedule Management — keep in step with
                SCHEDULE_MANAGEMENT_PERMISSION in constants.js. */}
            <RestrictedRoute
              path="/schedule-management"
              permission={SCHEDULE_MANAGEMENT_PERMISSION}
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <DoctorScheduling />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/care_context"
              permission="create and link visit purpose"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <CreateCareContext setSearchText={setSearchText} />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/care_context_non_abdm"
              permission="create and link visit purpose"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <CareContextCreationNonAbdm setSearchText={setSearchText} />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute path="/upload_report" permission="upload reports">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <UploadReport setSearchText={setSearchText} />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/register_patient"
              permission="manage patients"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <RegisterPatient setSearchText={setSearchText} />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>
            <Route exact path="/register_patient_ipd">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <PatientAdmissionIpd />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <Route exact path="/doctor_console_ipd">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <DoctorConsoleIpd setSearchText={setSearchText} />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <Route exact path="/nurse_tasks">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <NurseTasks />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <Route exact path="/allocation_dashboard">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <BedAllocation />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <Route exact path="/bed_retention_management">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <BedRetentionManagement />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <Route exact path="/bed_transfer_requisition">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <BedTransferRequisitionList />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <Route exact path="/admitted_discharged_patients">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <IpdPatientRegisterShell />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <Route exact path="/emergency_to_ipd">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <EmergencyToIpdForm />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <Route exact path="/ipd_approvals">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <ApprovalsCenter />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <Route exact path="/cancellation_rules">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <CancellationRulesAdmin />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <Route exact path="/housekeeping_settings">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <HousekeepingSettingsAdmin />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <RestrictedRoute
              exact
              path="/emergency_tracking_board"
              permission="emergency_dashboard"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <EmergencyShell>
                    <EmergencyTrackingBoard />
                  </EmergencyShell>
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>
            <RestrictedRoute
              exact
              path="/emergency_all_visits"
              permission="emergency_dashboard"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <EmergencyShell>
                    <EmergencyAllVisits />
                  </EmergencyShell>
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>
            <RestrictedRoute
              exact
              path="/emergency_bed_management"
              permission="emergency_dashboard"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <EmergencyShell>
                    <EmergencyBedManagement />
                  </EmergencyShell>
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>
            <RestrictedRoute
              exact
              path="/emergency_death_register"
              permission="emergency_dashboard"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <EmergencyShell>
                    <EmergencyDeathRegister />
                  </EmergencyShell>
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>
            <RestrictedRoute
              exact
              path="/emergency_visit/:visitId"
              permission="emergency_dashboard"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <EmergencyShell>
                    <EmergencyVisitDetail />
                  </EmergencyShell>
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>
            <RestrictedRoute
              exact
              path="/emergency_register_patient"
              permission="emergency_register"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <EmergencyShell>
                    <EmergencyRegisterPatient />
                  </EmergencyShell>
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>
            <RestrictedRoute
              exact
              path="/emergency_department_setup"
              permission="emergency_dashboard"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <EmergencyShell>
                    <EmergencyDepartmentSetup />
                  </EmergencyShell>
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>
            <Route exact path="/nurse_dashboard">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <NurseDashboardShell section="nurse" />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <Route exact path="/nursing_manager">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <NurseDashboardShell section="manager" />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            {/* OT module. More specific paths first — react-router v5 matches in order. */}
            <RestrictedRoute exact path="/ot_dashboard/schedule" permission="ot_schedule">
              <OTAppShell setSearchText={setSearchText}>
                <OtSchedule />
              </OTAppShell>
            </RestrictedRoute>
            <RestrictedRoute exact path="/ot_dashboard/cases/new" permission="ot_schedule">
              <OTAppShell setSearchText={setSearchText}>
                <OtCaseNew />
              </OTAppShell>
            </RestrictedRoute>
            <RestrictedRoute exact path="/ot_dashboard/cases" permission="ot_schedule">
              <OTAppShell setSearchText={setSearchText}>
                <OtCases />
              </OTAppShell>
            </RestrictedRoute>
            <RestrictedRoute exact path="/ot_dashboard/case/:id" permission="ot_schedule">
              <OTAppShell setSearchText={setSearchText}>
                <OtCaseDetail />
              </OTAppShell>
            </RestrictedRoute>
            <RestrictedRoute exact path="/ot_dashboard/board" permission="ot_schedule">
              <OTAppShell setSearchText={setSearchText}>
                <OtBoard />
              </OTAppShell>
            </RestrictedRoute>
            <RestrictedRoute exact path="/ot_dashboard/orders" permission="ot_schedule">
              <OTAppShell setSearchText={setSearchText}>
                <OtOrders />
              </OTAppShell>
            </RestrictedRoute>
            <RestrictedRoute exact path="/ot_dashboard/final-list" permission="ot_schedule">
              <OTAppShell setSearchText={setSearchText}>
                <OtFinalList />
              </OTAppShell>
            </RestrictedRoute>
            <RestrictedRoute exact path="/ot_dashboard/reports" permission="ot_schedule">
              <OTAppShell setSearchText={setSearchText}>
                <OtReports />
              </OTAppShell>
            </RestrictedRoute>
            <RestrictedRoute exact path="/ot_dashboard/masters" permission="ot_schedule">
              <OTAppShell setSearchText={setSearchText}>
                <OtMasters />
              </OTAppShell>
            </RestrictedRoute>
            <RestrictedRoute exact path="/ot_dashboard" permission="ot_schedule">
              <OTAppShell setSearchText={setSearchText}>
                <OtDashboard />
              </OTAppShell>
            </RestrictedRoute>
            <RestrictedRoute
              exact
              path="/ot-charge-capture"
              permission="ot charge capture"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <OtChargeCapture />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>
            <Route exact path="/ipd-billing">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingDashboard />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/journey">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingPatientJourney />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/charge-capture">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingChargeCapture />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/charge-capture/add">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingAddCharge />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/deposits">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingDeposits />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/insurance">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingInsurance />
              </IPDBillingAppShell>
            </Route>
            {/* TPA workspace — the Insurance & Claims screen with the billing
                sidebar narrowed to that one nav item. */}
            <Route exact path="/tpa">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingInsurance navIds={["insurance"]} autoOnly />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/invoices">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingInvoice />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/refund-cancel">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingRefundCancel />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/cash-counter">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingCashCounter />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/approvals">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingApprovals />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/ledger">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingLedger />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/discharge">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingDischarge />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/reports">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingReports />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/pricing">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingPricing />
              </IPDBillingAppShell>
            </Route>
            <Route exact path="/ipd-billing/payouts">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <IPDBillingPayouts />
              </IPDBillingAppShell>
            </Route>

            {/* Corporate rate-card admin (manager tile → /corporate-rate-card) */}
            <Route exact path="/corporate-rate-card">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <CorporateRateCard />
              </IPDBillingAppShell>
            </Route>

            {/* Scheme service-name admin (manager tile → /scheme-service-names) */}
            <Route exact path="/scheme-service-names">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <SchemeServiceNames />
              </IPDBillingAppShell>
            </Route>

            {/* Billing manager dashboard (manager tile → /billing-manager-dashboard) */}
            <Route exact path="/billing-manager-dashboard">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <BillingManagerDashboard />
              </IPDBillingAppShell>
            </Route>

            {/* Package billing admin (manager tile → /package-billing) */}
            <Route exact path="/package-billing">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <PackageBilling />
              </IPDBillingAppShell>
            </Route>

            {/* Package dashboard (patient-scoped — linked from the Charge Capture package badge) */}
            <Route exact path="/ipd-billing/package-dashboard">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <PackageDashboard />
              </IPDBillingAppShell>
            </Route>

            {/* Service Master admin (manager tile → /service-master) */}
            <Route exact path="/service-master">
              <IPDBillingAppShell setSearchText={setSearchText}>
                <ServiceMaster />
              </IPDBillingAppShell>
            </Route>

            {/* Mobile QR scan page — no auth wrapper, accessed from phone */}
            <Route exact path="/ipd-mobile-scan">
              <MobileScan />
            </Route>

            <RestrictedRoute
              path="/add_update_services"
              permission="manage facilities"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <AddUpdateServices setSearchText={setSearchText} />
              </DoctorLayout>
            </RestrictedRoute>
            <Route exact path="/patient_details">
              <DoctorLayout setSearchText={setSearchText}>
                <PatientDetails setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route
              exact
              path="/:patientFlow(register_patient_qr|patient_login|book_appointment|my_appointment|patient_dashboard)"
              render={({ match }) => (
                <PatientRegistrationWizard
                  setSearchText={setSearchText}
                  initialView={
                    match.params.patientFlow === "patient_login"
                      ? "login"
                      : match.params.patientFlow === "book_appointment"
                        ? "voice"
                        : match.params.patientFlow === "my_appointment"
                          ? "appointments"
                          : match.params.patientFlow === "patient_dashboard"
                            ? "dashboard"
                            : undefined
                  }
                />
              )}
            />
            <RestrictedRoute path="/scan_qr" permission="view qr">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <ScanPatientQR setSearchText={setSearchText} />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>
            <RestrictedRoute path="/patient-local-data" permission="manage patients">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <PatientRecords />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            {/* <Route exact path="/patient_details">
              <DoctorLayout setSearchText={setSearchText}>
                <PatientDetails setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route exact path="/register_patient_qr">
              <PatientRegistrationWizard setSearchText={setSearchText} />
            </Route>
            <RestrictedRoute path="/scan_qr" permission="view qr">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <ScanPatientQR setSearchText={setSearchText} />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute> */}

            <Route exact path="/login">
              <DoctorLayout setSearchText={setSearchText}>
                <Login setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>

            <Route exact path="/License">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <License setSearchText={setSearchText} />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>

            <Route exact path="/testweek">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <WeekCalender setSearchText={setSearchText} />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>

            <RestrictedRoute
              path="/transaction_records"
              permission="manage billing and transaction"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <TransactionRecords setSearchText={setSearchText} />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/doctor/patient"
              permission="manage patients"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <Patient />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/scan_share_records"
              permission="scan and share records"
            >
              <DoctorLayout>
                <LayoutWithbg>
                  <ScanShareRecords />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            {/* <RestrictedRoute path="/doctor/Reports" permission="reports">
            <DoctorLayout setSearchText={setSearchText}>
              <ReportChart />
            </DoctorLayout>
          </RestrictedRoute> */}

            <RestrictedRoute path="/reports" permission="reports">
              <DoctorLayout setSearchText={setSearchText}>
                <Reports />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/doctor/DoctorConsole"
              permission="add prescription"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <DoctorConsole />
              </DoctorLayout>
            </RestrictedRoute>
            <RestrictedRoute
              path="/doctor/QuickConsultation"
              permission="quick consultation"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <QuickConsultation />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/doctor/appointments"
              permission="manage appointments"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <Appointments />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            {/* Non use for now  */}
            <Route exact path="/manage_branding">
              <DoctorLayout setSearchText={setSearchText}>
                <BrandingManagement />
              </DoctorLayout>
            </Route>

            <Route exact path="/doctor-console-manager">
              <DoctorLayout setSearchText={setSearchText}>
                <DoctorConsoleManager />
              </DoctorLayout>
            </Route>
            <RestrictedRoute
              exact
              path="/case-sheet-access"
              permission="manage case sheet access"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <CaseSheetAccessManager />
              </DoctorLayout>
            </RestrictedRoute>
            <Route exact path="/doctor-upload" component={DataUploadByDoctor} />
            <Route exact path="/hlthtek-admin-demo">
              <DoctorLayout setSearchText={setSearchText}>
                <HlthtekAdminDemo
                  setSearchText={setSearchText}
                  setBrandingData={setBrandingData}
                />
              </DoctorLayout>
            </Route>

            <Route exact path="/doctor/landing">
              <DoctorLayout>
                <LandingPage setBrandingData={setBrandingData} />
              </DoctorLayout>
            </Route>

            <Route path="/doctor/home">
              <DoctorLayout home="home" setSearchText={setSearchText}>
                <DoctorHome setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>

            <Route path="/doctor/appointmentsCards">
              <DoctorLayout setSearchText={setSearchText}>
                <DoctorAppointmentsCards />
              </DoctorLayout>
            </Route>

            <Route exact path="/register">
              <DoctorLayout setSearchText={setSearchText}>
                <Register setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>

            <Route exact path="/generate_consent">
              <DoctorLayout setSearchText={setSearchText}>
                <GenerateConsent setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>

            <Route exact path="/hlthtek-demo">
              <DoctorLayout setSearchText={setSearchText}>
                <HlthtekDemo
                  setSearchText={setSearchText}
                  setBrandingData={setBrandingData}
                />
              </DoctorLayout>
            </Route>

            <Route exact path="/customer_details">
              <DoctorLayout setSearchText={setSearchText}>
                <FacilityCustomer updateList={updateList} />
                <ClientDetails refreshList={refreshList} />
              </DoctorLayout>
            </Route>

            <Route exact path="/partner_details">
              <DoctorLayout setSearchText={setSearchText}>
                <FacilityPartner updateList={updateList} />
                <PartnerDetails refreshList={refreshList} />
              </DoctorLayout>
            </Route>

            <RestrictedRoute path="/doctor/item" permission="view_item">
              <DoctorLayout setSearchText={setSearchText}>
                <Item />
              </DoctorLayout>
            </RestrictedRoute>

            {/* <RestrictedRoute path="/doctor/product" permission="view_product">
            <DoctorLayout setSearchText={setSearchText}>
              <Product />
            </DoctorLayout>
          </RestrictedRoute> */}

            {/* Cost Estimates - commented out for now */}
            {/* <RestrictedRoute
            path="/doctor/estimates"
            permission="view_estimate_list"
          >
            <DoctorLayout setSearchText={setSearchText}>
              <Estimate />
            </DoctorLayout>
          </RestrictedRoute> */}

            <RestrictedRoute
              path="/doctor/invoice"
              permission="view_invoice_list"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <Invoice />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/doctor/refund"
              permission="view_invoice_list"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <Refund />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute path="/doctor/payment" permission="view_payment">
              <DoctorLayout setSearchText={setSearchText}>
                <Payment />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute path="/doctor/report" permission="access_reports">
              <DoctorLayout setSearchText={setSearchText}>
                <SideNavbar />
                <Reports />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/doctor/DoctorConsole"
              permission="add prescription"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <DoctorConsole />
              </DoctorLayout>
            </RestrictedRoute>
            <RestrictedRoute
              path="/doctor/QuickConsultation"
              permission="quick consultation"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <QuickConsultation />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/viewInvoice/:id"
              permission="view_invoice"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <InvoiceReceiptTabs />
              </DoctorLayout>
            </RestrictedRoute>
            <RestrictedRoute
              path="/doctor/appointments"
              permission="manage appointments"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <Appointments />
                </LayoutWithbg>
              </DoctorLayout>
            </RestrictedRoute>

            {/* Non use for now  */}
            <Route exact path="/manage_branding">
              <DoctorLayout setSearchText={setSearchText}>
                <BrandingManagement />
              </DoctorLayout>
            </Route>
            <Route exact path="/hlthtek-admin-demo">
              <DoctorLayout setSearchText={setSearchText}>
                <HlthtekAdminDemo
                  setSearchText={setSearchText}
                  setBrandingData={setBrandingData}
                />
              </DoctorLayout>
            </Route>
            <RestrictedRoute
              exact
              path="/refundReceipt/:id"
              permission="view_invoice"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <RefundReceipt />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/editInvoice/:id"
              permission="edit_invoice"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <EditInvoice />
              </DoctorLayout>
            </RestrictedRoute>

            <Route exact path="/doctor/landing">
              <DoctorLayout>
                <LandingPage setBrandingData={setBrandingData} />
              </DoctorLayout>
            </Route>

            <Route path="/doctor/home">
              <DoctorLayout home="home" setSearchText={setSearchText}>
                <DoctorHome setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>

            <Route path="/doctor/appointmentsCards">
              <DoctorLayout setSearchText={setSearchText}>
                <DoctorAppointmentsCards />
              </DoctorLayout>
            </Route>

            <Route exact path="/register">
              <DoctorLayout setSearchText={setSearchText}>
                <Register setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>

            <Route exact path="/generate_consent">
              <DoctorLayout setSearchText={setSearchText}>
                <GenerateConsent setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>

            <Route exact path="/hlthtek-demo">
              <DoctorLayout setSearchText={setSearchText}>
                <HlthtekDemo
                  setSearchText={setSearchText}
                  setBrandingData={setBrandingData}
                />
              </DoctorLayout>
            </Route>

            <Route exact path="/customer_details">
              <DoctorLayout setSearchText={setSearchText}>
                <FacilityCustomer updateList={updateList} />
                <ClientDetails refreshList={refreshList} />
              </DoctorLayout>
            </Route>

            <Route exact path="/partner_details">
              <DoctorLayout setSearchText={setSearchText}>
                <FacilityPartner updateList={updateList} />
                <PartnerDetails refreshList={refreshList} />
              </DoctorLayout>
            </Route>

            <Route path="/doctor/tele-console-patient">
              <DoctorLayout setSearchText={setSearchText}>
                <Suspense fallback={<div />}>
                  <TeleConsolePatient />
                </Suspense>
              </DoctorLayout>
            </Route>

            <RestrictedRoute path="/doctor/item" permission="view_item">
              <DoctorLayout setSearchText={setSearchText}>
                <Item />
              </DoctorLayout>
            </RestrictedRoute>

            {/* <RestrictedRoute path="/doctor/product" permission="view_product">
              <DoctorLayout setSearchText={setSearchText}>
                <Product />
              </DoctorLayout>
            </RestrictedRoute> */}

            {/* <RestrictedRoute
              path="/doctor/estimates"
              permission="view_estimate_list"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <Estimate />
              </DoctorLayout>
            </RestrictedRoute> */}

            <RestrictedRoute
              path="/doctor/invoice"
              permission="view_invoice_list"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <Invoice />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute path="/doctor/payment" permission="view_payment">
              <DoctorLayout setSearchText={setSearchText}>
                <Payment />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute path="/doctor/report" permission="access_reports">
              <DoctorLayout setSearchText={setSearchText}>
                <SideNavbar>
                  <Reports />
                </SideNavbar>
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              path="/doctor/Staging"
              permission="access_staging_area"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <SideNavbar>
                  <StagingArea />
                </SideNavbar>
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/viewInvoice/:id"
              permission="view_invoice"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <ViewInvoice />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/editInvoice/:id"
              permission="edit_invoice"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <EditInvoice />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/newInvoice"
              permission="create_invoice"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <InvoiceAddition />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/invoicePreview"
              permission="preview_invoice"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <InvoicePreview />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/estimatePreview"
              permission="preview_estimate"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <EstimatePreview />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/editEstimate/:id"
              permission="edit_estimate"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <EditEstimate />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/viewEstimate/:id"
              permission="view_estimate"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <ViewEstimate />
              </DoctorLayout>
            </RestrictedRoute>

            <RestrictedRoute
              exact
              path="/newEstimate"
              permission="create_estimate"
            >
              <DoctorLayout setSearchText={setSearchText}>
                <EstimateAdditon />
              </DoctorLayout>
            </RestrictedRoute>

            {/* Do not know */}
            <Route path="/doctor/Prescription">
              <DoctorLayout setSearchText={setSearchText}>
                <Console />
              </DoctorLayout>
            </Route>

            <Route path="/doctor/Chart">
              <DoctorLayout setSearchText={setSearchText}>
                <ReportChart />
              </DoctorLayout>
            </Route>

            <Route path="/doctor/tele-console-patient">
              <DoctorLayout setSearchText={setSearchText}>
                <TeleConsolePatient />
              </DoctorLayout>
            </Route>
            <Route exact path="/consent">
              <DoctorLayout setSearchText={setSearchText}>
                <Consent setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route exact path="/admin_services">
              <DoctorLayout setSearchText={setSearchText}>
                <AdminServices setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route exact path="/get_existing_details">
              <DoctorLayout setSearchText={setSearchText}>
                <GetExistingDetails setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route exact path="/patient/appointments">
              <PatientLayout setSearchText={setSearchText}>
                <AppointmentsPatient setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/AccessDeniedPage">
              <NormalLayout setSearchText={setSearchText}>
                <AccessDeniedPage />
              </NormalLayout>
            </Route>
            <Route exact path="/processes">
              <NormalLayout setSearchText={setSearchText}>
                <ABDMData />
              </NormalLayout>
            </Route>
            <Route exact path="/legal">
              <NormalLayout setSearchText={setSearchText}>
                <ABDMData />
              </NormalLayout>
            </Route>
            <Route exact path="/faqs">
              <NormalLayout setSearchText={setSearchText}>
                <ABDMData />
              </NormalLayout>
            </Route>
            <Route exact path="/testpopup">
              <NormalLayout setSearchText={setSearchText}>
                <LicenseInfoPopup />
              </NormalLayout>
            </Route>
            <Route exact path="/faq">
              <PatientLayout setSearchText={setSearchText}>
                <HelpAndFaq setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/aboutHTMate">
              <PatientLayout setSearchText={setSearchText}>
                <HTMatedata />
              </PatientLayout>
            </Route>
            <Route exact path="/under-construction">
              <PatientLayout setSearchText={setSearchText}>
                <UnderConstruction setSearchText={setSearchText} />
              </PatientLayout>
            </Route>

            <Route exact path="/abdm-services">
              <PatientLayout setSearchText={setSearchText}>
                <AbdmServices setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/abdm-benefits">
              <PatientLayout setSearchText={setSearchText}>
                <AbdmBenefits setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/abdm-join">
              <PatientLayout setSearchText={setSearchText}>
                <AbdmJoin setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/health-repo">
              <PatientLayout setSearchText={setSearchText}>
                <HealthRepo setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/dtx-tool">
              <PatientLayout setSearchText={setSearchText}>
                <DtxTool setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/incentives-plan">
              <PatientLayout setSearchText={setSearchText}>
                <IncentivesPlan setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/fhir">
              <DoctorLayout setSearchText={setSearchText}>
                <FHIR setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            {/* <Route exact path="/recording-demo">
              <DoctorLayout setSearchText={setSearchText}>
                <DemoRecording setSearchText={setSearchText} />
              </DoctorLayout>
            </Route> */}
            <Route exact path="/patient/trend-analysis">
              <PatientLayout setSearchText={setSearchText}>
                <PatientTrendAnalysis setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/patient/tele-console-patient">
              <PatientLayout setSearchText={setSearchText}>
                <TeleConsolePatient setSearchText={setSearchText} />
              </PatientLayout>
            </Route>

            <Route path="/doctor/tele-console-patient">
              <DoctorLayout setSearchText={setSearchText}>
                <Suspense fallback={<div />}>
                  <TeleConsolePatient />
                </Suspense>
              </DoctorLayout>
            </Route>
            <Route exact path="/consent">
              <DoctorLayout setSearchText={setSearchText}>
                <Consent setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route exact path="/admin_services">
              <DoctorLayout setSearchText={setSearchText}>
                <AdminServices setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route exact path="/get_existing_details">
              <DoctorLayout setSearchText={setSearchText}>
                <GetExistingDetails setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route exact path="/patient/appointments">
              <PatientLayout setSearchText={setSearchText}>
                <AppointmentsPatient setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/AccessDeniedPage">
              <NormalLayout setSearchText={setSearchText}>
                <AccessDeniedPage />
              </NormalLayout>
            </Route>
            <Route exact path="/processes">
              <NormalLayout setSearchText={setSearchText}>
                <ABDMData />
              </NormalLayout>
            </Route>
            <Route exact path="/legal">
              <NormalLayout setSearchText={setSearchText}>
                <ABDMData />
              </NormalLayout>
            </Route>
            <Route exact path="/faqs">
              <NormalLayout setSearchText={setSearchText}>
                <ABDMData />
              </NormalLayout>
            </Route>
            <Route exact path="/testpopup">
              <NormalLayout setSearchText={setSearchText}>
                <LicenseInfoPopup />
              </NormalLayout>
            </Route>
            <Route exact path="/faq">
              <PatientLayout setSearchText={setSearchText}>
                <HelpAndFaq setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/aboutHTMate">
              <PatientLayout setSearchText={setSearchText}>
                <HTMatedata />
              </PatientLayout>
            </Route>
            <Route exact path="/under-construction">
              <PatientLayout setSearchText={setSearchText}>
                <UnderConstruction setSearchText={setSearchText} />
              </PatientLayout>
            </Route>

            <Route exact path="/abdm-services">
              <PatientLayout setSearchText={setSearchText}>
                <AbdmServices setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/abdm-benefits">
              <PatientLayout setSearchText={setSearchText}>
                <AbdmBenefits setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/abdm-join">
              <PatientLayout setSearchText={setSearchText}>
                <AbdmJoin setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/health-repo">
              <PatientLayout setSearchText={setSearchText}>
                <HealthRepo setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/dtx-tool">
              <PatientLayout setSearchText={setSearchText}>
                <DtxTool setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/incentives-plan">
              <PatientLayout setSearchText={setSearchText}>
                <IncentivesPlan setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/fhir">
              <DoctorLayout setSearchText={setSearchText}>
                <FHIR setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            {/* <Route exact path="/recording-demo">
              <DoctorLayout setSearchText={setSearchText}>
                <DemoRecording setSearchText={setSearchText} />
              </DoctorLayout>
            </Route> */}
            <Route exact path="/patient/trend-analysis">
              <PatientLayout setSearchText={setSearchText}>
                <PatientTrendAnalysis setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/patient/tele-console-patient">
              <PatientLayout setSearchText={setSearchText}>
                <Suspense fallback={<div />}>
                  <TeleConsolePatient setSearchText={setSearchText} />
                </Suspense>
              </PatientLayout>
            </Route>
            <Route path={`/doctor/home`}>
              <DoctorHome setSearchText={setSearchText} />
            </Route>
            <Route path={`/patient/home`}>
              <PatientHome setSearchText={setSearchText} />
            </Route>
            <Route path={`/resarch/home`}>
              <ResarchHome setSearchText={setSearchText} />
            </Route>
            <Route exact path="/resarch/home">
              <PatientLayout setSearchText={setSearchText}>
                <ResarchHome setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/patient/home">
              <PatientLayout setSearchText={setSearchText}>
                <PatientHome setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route path={`/resarch/home`}>
              <ResarchHome setSearchText={setSearchText} />
            </Route>
            <Route exact path="/resarch/home">
              <PatientLayout setSearchText={setSearchText}>
                <ResarchHome setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/patient/home">
              <PatientLayout setSearchText={setSearchText}>
                <PatientHome setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/patient/info">
              <PatientLayout setSearchText={setSearchText}>
                <PatientInfo setSearchText={setSearchText} />
              </PatientLayout>
            </Route>
            <Route exact path="/patient/diabeticblog">
              <NormalLayout setSearchText={setSearchText}>
                <DiabeticBlog setSearchText={setSearchText} />
              </NormalLayout>
            </Route>
            <Route exact path="/patient/healthysleepblog">
              <NormalLayout setSearchText={setSearchText}>
                <HealthySleepBlog setSearchText={setSearchText} />
              </NormalLayout>
            </Route>
            {/* POC Content  */}

            {/* <Route path="/doctor/observations">
            <DoctorLayout setSearchText={setSearchText}>
              <Observation />
            </DoctorLayout>
          </Route> */}

            {/* <Route path="/doctor/Billing">
            <DoctorLayout setSearchText={setSearchText}>
              <Billing />
            </DoctorLayout>
          </Route> */}

            <Route path="/doctor/AppointmentCalender">
              <DoctorLayout setSearchText={setSearchText}>
                <AppointmentCalender />
              </DoctorLayout>
            </Route>

            <Route path="/doctor/MonthCalender">
              <DoctorLayout setSearchText={setSearchText}>
                <MonthCalender />
              </DoctorLayout>
            </Route>

            <Route path="/doctor/WeekCalender">
              <DoctorLayout setSearchText={setSearchText}>
                <WeekCalender />
              </DoctorLayout>
            </Route>

            <Route path="/doctor/tele-console">
              <DoctorLayout setSearchText={setSearchText}>
                <TeleConsole />
              </DoctorLayout>
            </Route>

            <Route path="/doctor/telemedicine">
              <DoctorLayout setSearchText={setSearchText}>
                <Suspense fallback={<div />}>
                  <TelemedicineConsole />
                </Suspense>
              </DoctorLayout>
            </Route>

            <Route path="/doctor/Timeline">
              <DoctorLayout setSearchText={setSearchText}>
                <TimelineMain />
              </DoctorLayout>
            </Route>

            <Route path="/doctor/Dicom">
              <DoctorLayout setSearchText={setSearchText}>
                <DicomMain />
              </DoctorLayout>
            </Route>
            <Route path="/doctor/Wellness">
              <DoctorLayout setSearchText={setSearchText}>
                <WellnessMainPage />
              </DoctorLayout>
            </Route>
            <Route exact path="/exchange_patient_emr">
              <DoctorLayout setSearchText={setSearchText}>
                <ExchangePatientEMR setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route exact path="/InitialObservation">
              {/* <NormalLayout setSearchText={setSearchText}> */}
              <InitialObservation />
              {/* </NormalLayout> */}
            </Route>

            <Route exact path="/chatPdf">
              <DoctorLayout setSearchText={setSearchText}>
                <ChatPdf setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route exact path="/connector_visualization">
              <ConnectorVisualization />
            </Route>
            <Route exact path="/websiteAppointments">
              <WebsiteIntegration />
            </Route>
            <Route path="/DbTest">
              <IndexedDBManager />
            </Route>
            <Route exact path="/room" component={VideoConfMain} />
            <Route exact path="/contact" component={ContactUs} />
            <Route path="/room/:roomId" component={VideoConfRoom} />
            <Route path="/search">
              <Search searchText={searchText} setSearchText={setSearchText} />
            </Route>

            {/* Non protected route */}
            <Route exact path="/landing-page">
              {/* <NormalLayout setSearchText={setSearchText}> */}
              <MainLanding />
              {/* </NormalLayout> */}
            </Route>
            <Route exact path="/">
              <DoctorLayout setSearchText={setSearchText}>
                <Login setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route exact path="/HTHRPHealthRepositoryProvider">
              <DoctorLayout setSearchText={setSearchText}>
                <HTHRPHealthRepositoryProvider setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route exact path="/HTBridgeConnector">
              <DoctorLayout setSearchText={setSearchText}>
                <HTBridgeConnector setSearchText={setSearchText} />
              </DoctorLayout>
            </Route>
            <Route exact path="/abdm">
              <NormalLayout setSearchText={setSearchText}>
                <ABDMData />
              </NormalLayout>
            </Route>
            <Route exact path="/termsAndConditions">
              <DoctorLayout>
                <FooterDetails />
              </DoctorLayout>
            </Route>
            <Route exact path="/privacyAndPolicy">
              <DoctorLayout>
                <FooterDetails />
              </DoctorLayout>
            </Route>
            <Route exact path="/cookies">
              <DoctorLayout>
                <FooterDetails />
              </DoctorLayout>
            </Route>
            <Route exact path="/aboutus">
              <DoctorLayout>
                <AboutUs />
              </DoctorLayout>
            </Route>
            <Route exact path="/newsAndMedia">
              <DoctorLayout>
                <NewsAndMedia />
              </DoctorLayout>
            </Route>
            {/* Added route for UploadReport with LayoutWithbg */}
            <Route exact path="/upload-report">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <UploadReport />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>

            {/* Inventory Suite */}
            <Route path="/inventory-suite">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <InventoryApp />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
            <Route exact path="/inv-settings">
              <DoctorLayout setSearchText={setSearchText}>
                <LayoutWithbg>
                  <InvSettings />
                </LayoutWithbg>
              </DoctorLayout>
            </Route>
          </Switch>
        </IpdDataProvider>

        <PasswordChangeModal
          open={forcePwdModalOpen}
          enforceChange={true}
          onClose={() => {
            setForcePwdModalOpen(false);
            setPasswordChanged(true);
            if (typeof refreshPermissions === "function") {
              refreshPermissions();
            }
          }}
        />

        <StorageUsageDialogInside
          open={showStoragePopup}
          setOpen={setShowStoragePopup}
          message={popupMessage}
          shouldLogout={shouldLogout}
          onLogout={Logout}
        />
      </Router>
    </BrandingProvider>
  );
}

export default App;
